var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vux-spinner",class:_vm.className})
}
var staticRenderFns = []

export { render, staticRenderFns }